<template>
    <div class="account-info box">
        <div class="box-title">
            Account Info
        </div>
        <div class="box-content">
            <form
                id="user-name-change"
                novalidate
                @submit.prevent="validate"
            >
                <div class="field flex">
                    <span class="field-title">Name</span>
                    <div class="input">
                        <fieldset
                            :class="{ error: nameErrorMessage }"
                        >
                            <input
                                v-model="user.name"
                                type="text"
                                name="name"
                                autocomplete="off"
                                :class="{ error: nameErrorMessage }"
                                @click="clearError()"
                            >
                            <span
                                v-if="nameErrorMessage"
                                class="form-error"
                            >
                                {{ nameErrorMessage }}
                            </span>
                        </fieldset>
                    </div>
                </div>
                <div class="field flex">
                    <span class="field-title">Email Address</span>
                    <div class="input">
                        <fieldset
                            :class="{ error: emailErrorMessage }"
                        >
                            <input
                                v-model="user.email"
                                type="text"
                                name="email"
                                autocomplete="off"
                                :class="{ error: emailErrorMessage }"
                                @click="clearError()"
                            >
                            <span
                                v-if="emailErrorMessage"
                                class="form-error"
                            >
                                {{ emailErrorMessage }}
                            </span>
                        </fieldset>
                    </div>
                </div>
                <div class="controll-container flex">
                    <base-form-button
                        class="btn"
                        :loading="formProcessing"
                    >
                        Save Changes
                    </base-form-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import toasts from '@/mixins/toasts';

import apiCall from '@/utils/apiCall';
import { emailValidator, userNameValidator } from '@/utils/form/validation.js';

export default {
    mixins: [toasts],

    data: () => ({
        user: {
            name: null,
            email: null,
        },
        emailErrorMessage: null,
        nameErrorMessage: null,
        formProcessing: false,
    }),

    computed: {
        ...mapState({
            baseUser: 'user',
        }),
    },

    /**
     * Created hook
     *
     */
    created() {
        this.user.name = this.baseUser.name;
        this.user.email = this.baseUser.email;
    },

    methods: {
        ...mapActions(['updateUser']),

        /**
         * Clears errors
         *
         */
        clearError() {
            this.emailErrorMessage = null;
            this.nameErrorMessage = null;
        },

        /**
         * Validates user data
         *
         */
        validate() {
            const { name, email } = this.user;

            if (! emailValidator(email)) {
                this.emailErrorMessage = 'Please enter valid email adress';
            }

            const nameValidation = userNameValidator(name);

            if (! nameValidation.validation) {
                this.nameErrorMessage = nameValidation.message;
            }

            if (this.nameErrorMessage || this.emailErrorMessage) {
                return;
            }

            this.saveUserData();
        },

        /**
         * Saves user data
         *
         */
        async saveUserData() {
            const { status, data } = await apiCall(this, 'put', '/api/user', this.user);

            if (200 === status) {
                this.formProcessing = true;

                await this.updateUser();

                this.formProcessing = false;

                this.toastSuccess({
                    message: {
                        title: 'Your Account Info has been changed',
                    },
                });
            } else if (422 === status) {
                const { errors, message } = data;

                this.emailErrorMessage = errors.email[0] ?? message;
            } else {
                this.toastError({
                    message: {
                        title: 'An error occured, please try again later',
                    },
                });
            }
        },
    },
};
</script>
